/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { NewsMediaCardsSectionFragment } from "@cosmos/hygraph-schema";
import { extractBackgroundContainerProps, extractSectionContainerProps } from "@components/utils/section.utils";

import {
	ButtonList,
	ResponsiveContainer,
	SectionContainer,
	BackgroundContainer,
	TitleDescStack,
} from "@components/elements";
import { css } from "@panda/css";
import { VStack } from "@panda/jsx";

import { NewsMediaCards } from "./NewsMediaCards.organism";

const styled = css({
	smDown: {
		gap: "eds.dimension.40",
	},
	"& .title-desc-stack": {
		alignItems: "center",
		textAlign: "center",
		"& .heading": {
			textStyle: "heading2XL",
			smDown: {
				textStyle: "headingXL",
			},
		},
		"& .paragraph": {
			color: "eds.text.secondary",
		},
	},
});

export const NewsMediaCardsSection = ({ config, cards }: NewsMediaCardsSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);

	const buttonsSource = config?.heading?.modButtons?.length ? config?.heading?.modButtons : config?.heading?.buttons;
	const validContent = Boolean(cards?.length || buttonsSource?.length);

	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer {...extractBackgroundContainerProps(config)}>
			<ResponsiveContainer>
				<SectionContainer {...extractSectionContainerProps(config)}>
					<VStack alignItems="center" gap="eds.dimension.48" className={`news-media-cards-section ${styled}`}>
						{validHeading ? (
							<TitleDescStack title={{ ...config?.heading?.title }} description={{ html: config?.heading?.desc }} />
						) : null}
						{validContent ? (
							<>
								<NewsMediaCards cards={cards || []} />
								<ButtonList
									buttons={
										buttonsSource?.map((button) => {
											return { ...button, size: "lg" };
										}) || []
									}
								/>
							</>
						) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
